import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\t\t\tmargin-left: ", ";\n\t\t\tmargin-right: ", ";\n\t\t"]);

  _templateObject4 = function () {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\t\t\tmargin-bottom: ", ";\n\t\t\tmargin-top: ", ";\n\t\t"]);

  _templateObject3 = function () {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\t\t\tmargin-bottom: ", ";\n\t\t"]);

  _templateObject2 = function () {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\t\t\tmargin-top: ", ";\n\t\t"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { contextConnect, useContextSystem } from '@wp-g2/context';
import { css, cx, ui } from '@wp-g2/styles';
import { is } from '@wp-g2/utils';
import React, { useMemo } from 'react';
import { Separator } from 'reakit';
import { useDropdownContext } from '../Dropdown';
import * as styles from './Divider.styles';

function Divider(props, forwardedRef) {
  var _useContextSystem = useContextSystem(props, 'Divider'),
      className = _useContextSystem.className,
      m = _useContextSystem.m,
      mb = _useContextSystem.mb,
      mt = _useContextSystem.mt,
      otherProps = _objectWithoutProperties(_useContextSystem, ["className", "m", "mb", "mt"]);

  var _useDropdownContext = useDropdownContext(),
      dropdownMenu = _useDropdownContext.menu;

  var isWithinDropdown = !!dropdownMenu;
  var classes = useMemo(function () {
    var sx = {};
    sx.mt = css(_templateObject(), ui.space(mt));
    sx.mb = css(_templateObject2(), ui.space(mb));
    sx.m = css(_templateObject3(), ui.space(m), ui.space(m));
    sx.dropdown = css(_templateObject4(), ui.space(-1), ui.space(-1));
    return cx(styles.Divider, !is.defined(m) && is.defined(mb) && sx.mb, !is.defined(m) && is.defined(mt) && sx.mt, is.defined(m) && sx.m, isWithinDropdown && sx.dropdown, className);
  }, [className, isWithinDropdown, m, mb, mt]);
  return /*#__PURE__*/React.createElement(Separator, Object.assign({}, otherProps, {
    className: classes,
    ref: forwardedRef
  }));
}

export default contextConnect(Divider, 'Divider');